import { EnvironmentProvider, LanguageProvider, TRANSLATIONS_APP_NAME, TranslationsContext, TranslationsContextWrapper, } from '@telia-common-components/shared';
import React from 'react';
import { TvPackageOfferingWrapper } from './TvPackageOfferingWrapper';
export const TvPackageOfferingCards = (props) => {
    const propsWithFixedTags = {
        ...props,
        packageData: props.packageData.map((packet) => {
            const tagsTop = packet.tagTop && !packet.tagsTop ? [packet.tagTop] : packet.tagsTop;
            return {
                ...packet,
                tagsTop: (tagsTop === null || tagsTop === void 0 ? void 0 : tagsTop.length) ? tagsTop : undefined,
            };
        }),
    };
    return (React.createElement(EnvironmentProvider, { app: props.app, tier: props.tier },
        React.createElement(LanguageProvider, { lang: props.language },
            React.createElement(TranslationsContextWrapper, { translations: props.translations, disableStatistics: props.disableTranslationsStatistics, isTestEnvironment: props.isTestEnvironment },
                React.createElement(TranslationsContext.Consumer, null, ({ translateOrEmpty }) => (React.createElement(TvPackageOfferingWrapper, { ...propsWithFixedTags, translate: (key, paramObject) => translateOrEmpty(TRANSLATIONS_APP_NAME, key, paramObject, false) })))))));
};
